<template>
  <div id="app">
    <Loading v-if="$store.state.isLoading" :message="'Loading...'"></Loading>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Loading from '@/components/Loading'

export default {
  name: 'app',
  components: {
    Loading, Footer
  }
}
</script>
